const stringToLocation = (str: string) => {
  return parseFloat(str.replace(',', '.'));
};

export default stringToLocation;
